// Shared config for the UPI component tree. The normal UPI flow and the UPI
// one-time-mandate (OTM) flow use identical logic and differ only by these
// brand / method strings (and the mandate variant attaching `oneTimeMandate`
// to the QR payload). Pass a `variant` prop down the tree and read the strings
// from here instead of hardcoding them.
export const UPI_VARIANTS = {
  upi: {
    methodName: "Upi", // dictionary key, analytics method, active-method for collect
    collectBrand: "UpiCollect",
    intentBrand: "UpiIntent",
    qrBrand: "UpiQr",
    isMandate: false,
  },
  mandate: {
    methodName: "UpiOneTimeMandate",
    collectBrand: "UpiCollectOtm",
    intentBrand: "UpiIntentOtm",
    qrBrand: "UpiQrOtm",
    isMandate: true,
  },
};

export const getUpiVariant = (variant) => UPI_VARIANTS[variant] || UPI_VARIANTS.upi;
